<p>theme-option-elements-chart-gauge-shadow-vertical-offset works!</p>
